// subsidiary.service.ts
import api from "./api.service";
import midiaService from "./midia.service";

export interface SubsidiaryData {
  subsidiaryUuid: string;
  subsidiaryName?: string;
  subsidiaryTaxPayerID?: string;
  subsidiaryEmail?: string;
  subsidiaryPhone?: string;
  subsidiaryAddress?: string;
  subsidiaryDescription?: string;
  subsidiaryLogoUrl?: string;
  subsidiaryVirtualAddress?: string;
  subsidiaryStatus?: boolean;
  companyUuid?: string;
}

class SubsidiaryClass {
  async getSubsidiaries(companyUuid?: string) {
    const url = companyUuid
      ? `/subsidiaries?companyUuid=${companyUuid}`
      : "/subsidiaries";
    const response = await api.get(url);
    return response.data;
  }

  async getSubsidiary(subsidiaryUuid: string) {
    const response = await api.get(`/subsidiary/${subsidiaryUuid}`);
    return response.data;
  }

  async createSubsidiary(data: Partial<SubsidiaryData>) {
    const response = await api.post("/subsidiary", data);
    return response.data;
  }

  async updateSubsidiary(data: Partial<SubsidiaryData>) {
    const response = await api.patch(
      `/subsidiary/${data.subsidiaryUuid}`,
      data
    );
    return response.data;
  }

  async deleteSubsidiary(subsidiaryUuid: string) {
    const response = await api.delete(`/subsidiary/${subsidiaryUuid}`);
    return response.data;
  }

  async updateSubsidiaryLogo(
    imageFile: File,
    subsidiary: SubsidiaryData
  ): Promise<{ token: string }> {
    let imageUrl: string;

    imageUrl = await midiaService.enviar(imageFile, "unidade");

    // Envia a URL para o backend
    const response = await api.patch(
      `/subsidiary/${subsidiary.subsidiaryUuid}`,
      {
        ...subsidiary,
        subsidiaryLogoUrl: imageUrl,
      }
    );

    return response.data;
  }

  async getSubsidiaryStats(subsidiaryUuid: string) {
    const response = await api.get(`/subsidiary/${subsidiaryUuid}/stats`);
    return response.data;
  }

  /**
   * Meios de pagamento da filial (subsidiaryInfoType 20). Grava em acd e
   * enfileira a descida para o PDV; a resposta traz o `infoToken` regenerado e o
   * bloco `fila` com a mensagem para o usuário.
   */
  async updatePagamento(
    subsidiaryUuid: string,
    body: {
      valor: any;
      aplicarEm: "agora" | "proximoPeriodo";
      updatedBy: string;
    }
  ) {
    const response = await api.patch(
      `/subsidiaryInfo/${subsidiaryUuid}/pagamento`,
      body
    );
    return response.data;
  }

  /** O que está na fila de configuração desta filial (pendentes e conflitos). */
  async getFilaPorFilial(subsidiaryUuid: string) {
    const response = await api.get(`/filaConfig/subsidiary/${subsidiaryUuid}`);
    return response.data;
  }
}

export const subsidiaryService = new SubsidiaryClass();
